import { render, staticRenderFns } from "./RequestWorkshop.vue?vue&type=template&id=db8c704c&"
import script from "./RequestWorkshop.vue?vue&type=script&lang=js&"
export * from "./RequestWorkshop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports